import React, { useEffect, useState } from 'react';
import { Card, Descriptions, Badge, Spin, Breadcrumb } from 'antd';
import { useParams } from 'react-router-dom';
import { chauffeursService } from '../../common/services';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';

const DetailChauffeur = () => {
  const { id } = useParams();
  const [chauffeur, setChauffeur] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;

    chauffeursService.getDetailChauffeur(id)
      .then(setChauffeur)
      .catch((err) => console.error("Erreur chargement chauffeur :", err))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading || !chauffeur) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <Spin tip="Chargement des détails..." size="large" />
      </div>
    );
  }

  const fullName = `${chauffeur.person.full_name.last_name} ${chauffeur.person.full_name.first_name}`;
  const phone = chauffeur.person.contact_info.phone;
  const license = chauffeur.person.driver_license;
  const profile = chauffeur.profile;
  const balance = chauffeur.balance;
  const isConnected = chauffeur.isConnected;

  return (
    <div className="container" style={{ padding: 24 }}>
      <Breadcrumb
          separator={<RightOutlined style={{ fontSize: '16px', color: '#999', fontWeight: 'bolder' }} />}
          style={{ marginBottom: 16 }}
      >
          <Breadcrumb.Item>
              <Link to="/dashboard" style={{ fontSize: '16px', fontWeight: 'bolder' }}>🏠 Accueil</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
              <Link to="/dashboard/chauffeurs" style={{ fontSize: '16px', fontWeight: 'bolder' }}>👥 Chauffeurs</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item><span style={{ fontSize: '16px', fontWeight: 'bolder' }}>🔍 Détail</span></Breadcrumb.Item>
      </Breadcrumb>
      {/* --------- Détails du chauffeur --------- */}
      <Card title={`Détail du chauffeur : ${fullName}`} bordered={false}>
        <Descriptions
          bordered
          layout="vertical"
          size="middle"
          column={{
            xs: 1,
            sm: 1,
            md: 2,
            lg: 2
          }}
        >
          <Descriptions.Item label="Nom complet">{fullName}</Descriptions.Item>
          <Descriptions.Item label="Téléphone">{phone}</Descriptions.Item>
          <Descriptions.Item label="Date de naissance">
            {dayjs(license.birth_date).format('DD/MM/YYYY')}
          </Descriptions.Item>
          <Descriptions.Item label="Permis de conduire">{license.number}</Descriptions.Item>
          <Descriptions.Item label="Date de délivrance">
            {dayjs(license.issue_date).format('DD/MM/YYYY')}
          </Descriptions.Item>
          <Descriptions.Item label="Expiration du permis">
            {dayjs(license.expiry_date).format('DD/MM/YYYY')}
          </Descriptions.Item>
          <Descriptions.Item label="Date d'embauche">
            {dayjs(profile.hire_date).format('DD/MM/YYYY')}
          </Descriptions.Item>
          <Descriptions.Item label="Statut de connexion">
            <Badge
              status={isConnected ? 'success' : 'default'}
              text={isConnected ? 'Connecté' : 'Déconnecté'}
            />
          </Descriptions.Item>
          <Descriptions.Item label="Solde">
            {parseFloat(balance.balance).toFixed(2)} {balance.currency}
          </Descriptions.Item>
          <Descriptions.Item label="Limite de solde">
            {parseFloat(balance.balance_limit).toFixed(2)} {balance.currency}
          </Descriptions.Item>
          <Descriptions.Item label="Statut">
            <Badge
              status={profile.work_status === 'working' ? 'processing' : 'error'}
              text={profile.work_status}
            />
          </Descriptions.Item>
          <Descriptions.Item label="ID véhicule">
            {chauffeur.car_id || 'Non assigné'}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      {/* --------- Détails du véhicule --------- */}
      {chauffeur.vehicle && (
        <Card title="Véhicule assigné" style={{ marginTop: 24 }}>
          <Descriptions
            bordered
            size="middle"
            column={{
              xs: 1,
              sm: 1,
              md: 2,
              lg: 2
            }}
          >
            <Descriptions.Item label="Marque">{chauffeur.vehicle.vehicle_specifications?.brand}</Descriptions.Item>
            <Descriptions.Item label="Modèle">{chauffeur.vehicle.vehicle_specifications?.model}</Descriptions.Item>
            <Descriptions.Item label="Année">{chauffeur.vehicle.vehicle_specifications?.year}</Descriptions.Item>
            <Descriptions.Item label="Plaque">{chauffeur.vehicle.vehicle_licenses?.licence_plate_number}</Descriptions.Item>
            <Descriptions.Item label="Statut">{chauffeur.vehicle.park_profile?.status}</Descriptions.Item>
            <Descriptions.Item label="Catégories">{chauffeur.vehicle.park_profile?.categories?.join(', ')}</Descriptions.Item>
            <Descriptions.Item label="Couleur">{chauffeur.vehicle.vehicle_specifications?.color}</Descriptions.Item>
            <Descriptions.Item label="Transmission">{chauffeur.vehicle.vehicle_specifications?.transmission}</Descriptions.Item>
          </Descriptions>
        </Card>
      )}

    </div>
  );
};

export default DetailChauffeur;
